import React, { useEffect, useState } from 'react';
import { getQueryString, pexios, toast } from "../../utils/functions";
import { history } from "../../utils/variables";
import {setUser, setToken, firstBoot, setRouterData, setInsuranceCode} from '../../redux/actions';
import { useDispatch } from 'react-redux';
import Modal from "../../components/master/Modal";
import userEvent from '@testing-library/user-event';

export default function ThirdPartyLogin() {
    const dispatch = useDispatch();
    const [noName,setNoName] = useState(false)
    const [error,setError] = useState('')
    const [loader,setLoader] = useState(true)
    const [userName,setUserName] = useState({
        fname: '',
        lname: ''
    })

    useEffect(() => {
        (async function() {
            const token = await getQueryString('token');
            pexios('api/check_api_token','post',{token: token})
            .then((res)=>{
                const response = res.data.data;
                dispatch(setUser(response.user));
                dispatch(setToken(response.token));
                dispatch(setInsuranceCode(response.insuranceCode));
                dispatch(firstBoot(true));
                if(!response.user.fname || !response.user.lname){
                    setLoader(false)
                    setNoName(true)
                    return;
                }
                history.push('/')
            })
            .catch(err=>{
                setError(err.response.data.msg)
                setLoader(false)
            })
            // dispatch(setToken(token));
            // const accident_id = await getQueryString('accident_id');
            // const report_id = await getQueryString('report_id');
            // await pexios('api/v2/get_user')
            //     .then(res => {
            //         dispatch(setUser(res.data));
            //     });
            // dispatch(firstBoot(true));
            // if (accident_id) {
            //     dispatch(setRouterData({id: accident_id, type: 'accident'}));
            //     history.replace(`/waiting${window.location.search}`);
            // }
            // else if (report_id) {
            //     dispatch(setRouterData({id: report_id, type: 'report'}));
            //     history.replace(`/report-single${window.location.search}`);
            // }
            // else history.replace('/');
        })();
    }, [dispatch]);
    function changeText(value,type) {
        setUserName(prevState=>({
            ...prevState,
            [type]:value
        }))
    }
    function submit() {
        pexios('api/update_name','post',{fname:userName.fname,lname:userName.lname})
        .then(()=>{
            history.push('/')
        })
    }
    return (
        <>
        <Modal visible={loader}>
            <div className='loader-modal'>
                <i className='fas fa-spinner fa-spin'/>
            </div>
        </Modal>
        <Modal visible={noName}>
            <div className='modal-content text-justify p20'>
            <p className='text-justify mb20' style={{fontSize:'14px'}}>لطفا نام و نام خانوادگی خود را وارد نمایید</p>
            <div className='input-parent withIcon rtl mt10'>
                <input
                    value={userEvent.fname}
                    type='text'
                    placeholder='نام'
                    onChange={e => changeText(e.target.value, 'fname')}
                        
                />
                <i className='fas fa-user'/>
            </div>
            <div className='input-parent withIcon rtl mt10'>
                <input
                    value={userName.lname}
                    type='text'
                    placeholder='نام خانوادگی'
                    onChange={e => changeText(e.target.value, 'lname')}
                />
                <i className='fas fa-user'/>
            </div>
            <div className='d-flex justify-center mt20'>
                <button className={`btn w-50 btn-circle ${(!userName.fname || !userName.lname)? 'btn-disable': 'btn-white-purple'}`} disabled={!userName.fname || !userName.lname} onClick={submit}>ثبت</button>
            </div>
            </div>
        </Modal>
        {error &&
        <div className="err-modal">
            <div className="header-icon"><i className="fas fa-exclamation-triangle"/></div>
            <div className='error-msg'>
                <p>{error}</p>
            </div>
        </div>
        }
        <div className="flex1"></div>
        </>
    );
};
